import Modal from "@components/Modal";
import ProductReviewsImages from "@components/ProductReviews/ProductReviewsImages";

const ProductReviewsImagesModal = ({ reviewsWithImages, onImageSelect }) => {
  return (
    <Modal header="Galerie de imagini" id="reviews-images-modal">
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-[10px]">
        <ProductReviewsImages
          reviewsWithImages={reviewsWithImages}
          onImageSelect={onImageSelect}
        />
      </div>
    </Modal>
  );
};

export default ProductReviewsImagesModal;
